<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-xs-12 col-xl-6">
        <div v-for="(pillr, index) in pillars" :key="index" :class="['card', 'shadow', pillr]" style="overflow:auto;">
          <div class="card-body" style="min-width:700px;">
            <ul class="questions_tree mt-4">
              <tree-item
                v-if="renderCriteria"
                class="tree-item"
                :icon="pillarIcon(pillr)"
                :item="topicsTree[pillr]"
                :is-open-init="true"
                @criterionClicked="selectedPillar=pillr;fetchCriterionEvaluations($event, false);"
              ></tree-item>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-xl-6">
        <div id="results_scroll" class="d-xl-none"></div>
        <card v-if="selectedCriterionDto">
          <div class="mb-2" style="font-size: 25px;">{{ selectedCriterionDto.title }}</div>
          <table id="filters" class="" style="width:100%">
            <tbody>
              <tr>
                <td style="vertical-align:top;"><label>Year</label></td>
                <td>
                  <div class="form-group">
                    <select v-model="year" class="form-control" style="width:auto; height:35px; padding: 5px 10px 5px 10px;border-radius: 4px;border: 1px solid rgba(60,60,60,.26);" @change="fetchCriterionEvaluations(selectedCriterionDto, false)">
                      <option v-for="index in years" :key="index" :value="index">{{ index }}</option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="vertical-align:top;"><label>Industry</label></td>
                <td>
                  <div class="form-group">
                    <v-select id="industry_filter" 
                              :class="{empty: showIndustryFilterPlaceholder}" 
                              v-model="industryIds" 
                              @input="fetchCriterionEvaluations(selectedCriterionDto, false)" 
                              :options="industriesFlat" multiple 
                              @open="isIndustryFilterFocused=true" 
                              @close="isIndustryFilterFocused=false"></v-select>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="vertical-align:top;"><label>Country</label></td>
                <td>
                  <div class="form-group">
                    <v-select id="country_filter" 
                              :class="{empty: showCountryFilterPlaceholder}" 
                              v-model="countryIds" 
                              @input="fetchCriterionEvaluations(selectedCriterionDto, false)" 
                              :options="countriesFlat" multiple 
                              @open="isCountryFilterFocused=true" 
                              @close="isCountryFilterFocused=false"></v-select>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </card>
        <card v-if="loading || errorMessage !== ''" class="shadow">
          <div v-if="loading" class="text-warning">Loading, please wait...</div>
          <div v-if="errorMessage !== ''" class="text-danger">{{ errorMessage }}</div>
        </card>
        <card class="shadow" v-if="polarChartData">
          <div style="text-align:center;">
            <div v-if="isPolarDataNormalized" class="text-warning">Projected in scale of ten</div>
            <div class="text-right"><a href="javascript:void(0);" @click="fetchCriterionEvaluations(selectedCriterionDto, true)"><span class="icomoon-cloud-download"></span>&nbsp;export&nbsp;as&nbsp;excel</a></div>
          </div>
          <horizontal-bar-chart 
            :chart-data="polarChartData" 
            :extra-options="polarChartOptions">
          </horizontal-bar-chart>
        </card>
        <card class="shadow">
        <div v-if="companyEvaluations.length>0" class="table-responsive" style="overflow:auto;">
          <div class="mb-1" v-if="companyEvaluationsAverage !== null">
            <span class="text-warning">Average: {{ formatNumber(companyEvaluationsAverage) }}</span>
            <a class="pull-right" href="javascript:void(0);" @click="fetchCriterionEvaluations(selectedCriterionDto, true)"><span class="icomoon-cloud-download"></span>&nbsp;export&nbsp;as&nbsp;excel</a>
          </div>
          <table class="table" style="width: 100%; min-width:700px;">
            <tbody>
              <tr v-for="(row, index) in companyEvaluations" :key="index">
                <td class="company_logo">
                  <img v-if="row.companyLogoPath" height="50" :src="row.companyLogoPath" :alt="row.companyTradeTitle">
                  <i v-else class="icomoon-office height-50"></i>
                </td>
                <td class="company_trade_title">
                  <a :href="'/#/companies/' + row.companyId" target="_blank">{{ row.companyTradeTitle }}</a>
                </td>
                <td class="evaluation_answer">
                  <div v-if="selectedCriterionDto.isNumericIndex">
                    <div v-if="row.evaluationAnalystAnswerNumeric !== '' && row.evaluationAnalystAnswerNumeric !== null">
                      {{ formatNumber(row.evaluationAnalystAnswerNumeric) }}
                      <small v-if="row.evaluationAnalystAnswerText" class="pointer text-primary ml-1" @click="toggleCompanyEvaluationsNotes(index);"><i class="icomoon-info"></i> details</small>
                    </div>
                    <div v-else>
                      N/A
                      <small v-if="row.evaluationAnalystAnswerText" class="pointer text-primary ml-1" @click="toggleCompanyEvaluationsNotes(index);"><i class="icomoon-info"></i> details</small>
                    </div>
                    <div v-if="row.evaluationAnalystAnswerText" v-show="companyEvaluationsNotes.indexOf(index)>-1" v-html="row.evaluationAnalystAnswerText" class="text-muted evaluation_answer_notes"></div>
                  </div>
                  <div v-else>
                    <div v-if="row.evaluationAnalystAnswerText" v-html="row.evaluationAnalystAnswerText"></div>
                    <div v-else>N/A</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!loading && companyEvaluations.length===0 && selectedCriterionDto">No results found for {{ year }}</div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "../api";
import TreeItem from "../components/TreeItem";
import HorizontalBarChart from "../components/Charts/HorizontalBarChart";
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
export default {
  name: "Criteria",
  components: {
    TreeItem,
    HorizontalBarChart,
    vSelect
  },
  data () {
    return {
      loading: true,
      renderCriteria: false,
      errorMessage: '',
      topicsTree: {
        environmental: {
          title: 'Environmental Criteria',
          id: null,
          childrenDtos: []
        },
        social: {
          title: 'Social Criteria',
          id: null,
          childrenDtos: []
        },
        governance: {
          title: 'Governance Criteria',
          id: null,
          childrenDtos: []
        },
        financial: {
          title: 'Financial Criteria',
          id: null,
          childrenDtos: []
        },
        general: {
          title: 'General Criteria',
          id: null,
          childrenDtos: []
        },
      },

      years: [],
      year: (this.$route.query.year !== '' && !isNaN(this.$route.query.year)) ? parseInt(this.$route.query.year) : ((new Date).getFullYear()-1),
      industryIds: [],
      countryIds: [],
      companyEvaluations: [],
      companyEvaluationsNotes: [],
      companyEvaluationsAverage: null,
      selectedCriterionDto: null,
      frameworks: ['nza'],
      pillars: ['environmental'],
      selectedPillar: null,

      isPolarDataNormalized: false,
      polarChartData: null,
      polarChartOptions: {
        legend: false, 
        scales: {
          yAxes: [{ticks: {mirror: true, z: 1, padding: -5, fontColor: '#222222'}}]
        },
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              if (this.isPolarDataNormalized) {
                return data.labels[tooltipItem.index] + ': ' + this.formatNumber(this.companyEvaluations[tooltipItem.index].evaluationAnalystAnswerNumeric);
              } else {
                return data.labels[tooltipItem.index] + ': ' + this.formatNumber(tooltipItem.value);
              }
            }
          }
        }, 
        responsive: true,
        maintainAspectRatio: true,
      },

      industriesFlat: [],
      industriesIndex: {},
      isIndustryFilterFocused: false,

      countriesFlat: [],
      countriesIndex: {},
      isCountryFilterFocused: false,
    }
  },
  mounted () {
    this.fetchFrameworks();
    for (let i=2019; i<((new Date).getFullYear())+1; i++) {
      this.years.push(i);
    }
  },
  computed: {
    showIndustryFilterPlaceholder() {
      return this.industryIds.length === 0 && !this.isIndustryFilterFocused;
    },
    showCountryFilterPlaceholder() {
      return this.countryIds.length === 0 && !this.isCountryFilterFocused;
    }
  },
  methods: {
    fetchTopicsTree() {
      let self = this;
      Api.send('GET', '/prism/topics/all/tree?with_criteria=1', {})
      .then((response) => {
        self.errorMessage = '';
        self.topicsTree.environmental.childrenDtos = response.environmental;
        self.topicsTree.social.childrenDtos = response.social;
        self.topicsTree.governance.childrenDtos = response.governance;
        self.topicsTree.financial.childrenDtos = response.financial;
        self.topicsTree.general.childrenDtos = response.general;
        self.renderCriteria = true;
        self.fetchCountries();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.topicsTree.environmental.childrenDtos = [];
        self.topicsTree.social.childrenDtos = [];
        self.topicsTree.governance.childrenDtos = [];
        self.topicsTree.financial.childrenDtos = [];
        self.topicsTree.general.childrenDtos = [];
        self.loading = false;
      });
    },
    fetchCountries() {
      let self = this;
      Api.send('GET', '/prism/countries', {})
      .then((response) => {
        self.errorMessage = '';
        response.map((countryDto) => {
          self.countriesFlat.push({
            code: countryDto.id,
            label: countryDto.title
          });
          self.countriesIndex[countryDto.id] = countryDto.title;
        });
        self.countryIds = (self.$route.query.country !== '' && !isNaN(self.$route.query.country)) ? [{code: parseInt(self.$route.query.country), label: self.countriesIndex[parseInt(self.$route.query.country)]}] : [];
        self.fetchIndustriesTree();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchCriterionEvaluations(criterionDto, asExcel) {
      if (!criterionDto || !criterionDto.id) {
        return false;
      }
      let self = this;
      self.selectedCriterionDto = criterionDto;

      let x = document.querySelectorAll(".criterion_td");
      let i;
      for (i = 0; i < x.length; i++) {
        x[i].classList.remove("selected");
      }
      document.getElementById('criterion_td_' + self.selectedCriterionDto.id).classList.add("selected");

      if (!asExcel) {
        let scrollElement = document.getElementById('results_scroll');
        if (scrollElement.offsetParent === null) {
          document.body.scrollIntoView();
        } else {
          scrollElement.scrollIntoView();
        }
      }

      let _industryIds = self.industryIds.map((x) => {
        return x.code;
      });
      let _countryIds = self.countryIds.map((x) => {
        return x.code;
      });
      let url = '/prism/criterion/' + self.selectedCriterionDto.id + '/evaluations?year=' + self.year + '&industry=' + _industryIds.join('_') + '&country=' + _countryIds.join('_');
      if (asExcel) {
        let loggedUser = this.$root.getLoggedUser();
        location.replace(Api.getBaseUrl() + url + '&as_excel=1&bearer_token=' + loggedUser.token);
        return;
      }
      self.loading = true;
      Api.send('GET', url, {})
      .then((response) => {
        self.errorMessage = '';
        self.companyEvaluationsAverage = null;
        if (response.length) {
          if (self.selectedCriterionDto.isNumericIndex) {
            self.populatePolarChartData(response);
            let total = 0;
            for (let i in response) {
              let row = response[i];
              if (row.evaluationAnalystAnswerNumeric !== '' && row.evaluationAnalystAnswerNumeric !== null) {
                total = total + row.evaluationAnalystAnswerNumeric;
              }
            }
            self.companyEvaluationsAverage = total/response.length;
          } else {
            self.polarChartData = null;
          }
        } else {
          self.polarChartData = null;
        }
        self.companyEvaluations = response;
        self.companyEvaluationsNotes = [];
        self.loading = false;
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.polarChartData = null;
        self.companyEvaluations = [];
        self.companyEvaluationsNotes = [];
        self.loading = false;
      });
    },
    formatNumber(number) {
      if (number > 1000000000000) {
        return (number/1000000000000).toFixed(2) + 'T'
      }

      if (number > 1000000000) {
        return (number/1000000000).toFixed(2) + 'B'
      }

      if (number > 1000000) {
        return (number/1000000).toFixed(2) + 'M'
      }

      if (number > 1000) {
        return (number/1000).toFixed(2) + 'K'
      }

      return parseFloat(number).toFixed(4).replace(/0+$/, "").replace(/\.$/, "");
    },
    populatePolarChartData(response) {
      let chartData = response.map(v => v.evaluationAnalystAnswerNumeric);
      let min = Math.min(...chartData);
      let max = Math.max(...chartData);
      if (max>100 && min/max < 0.01) {
        //Normalized data
        this.isPolarDataNormalized = true;
        chartData = chartData.map((v) => {
          let nv = v/max*10;
          if (nv > 0.1) {
            nv = nv.toFixed(2);
          } else {
            if (nv > 0) {
              nv = 0.1;
            }
          }
          return nv;
        });
      } else {
        this.isPolarDataNormalized = false;
      }

      let datasetObject = {data: chartData};
      switch (this.selectedPillar) {
        case 'environmental':
          datasetObject['backgroundColor'] = 'rgb(106 225 171 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(106 225 171 / 0.83)';
          break;
        case 'social':
          datasetObject['backgroundColor'] = 'rgb(255 197 91 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(255 197 91 / 0.83)';
          break;
        case 'governance':
          datasetObject['backgroundColor'] = 'rgb(158 158 255 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(158 158 255 / 0.83)';
          break;
        case 'financial':
          datasetObject['backgroundColor'] = 'rgb(255 158 158 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(255 158 158 / 0.83)';
          break;
        case 'general':
          datasetObject['backgroundColor'] = 'rgb(231 231 236 / 0.73)';
          datasetObject['hoverBackgroundColor'] = 'rgb(231 231 236 / 0.83)';
          break;
      }

      this.polarChartData = {
        datasets: [datasetObject],
        labels: response.map(v => v.companyTradeTitle),
      };
    },
    fetchIndustriesTree() {
      let self = this;
      Api.send('GET', '/prism/industries/all/tree', {})
      .then((response) => {
        self.registerIndustriesFlat(response);
      })
      .catch((err) => {
        self.errorMessage = err.msg;
        self.industriesFlat = [];
      });
    },
    registerIndustriesFlat(industriesTree) {
      this.industriesFlat = [];
      for (let i in industriesTree) {
        this.registerIndustryChildren(industriesTree[i], '');
      }
      
      this.industryIds = (this.$route.query.industry !== '' && !isNaN(this.$route.query.industry)) ? [{code: parseInt(this.$route.query.industry), label: this.industriesIndex[parseInt(this.$route.query.industry)]}] : [];

      this.$nextTick(() => {
        let crit = null;
        if (this.$route.query.crit !== '' && !isNaN(this.$route.query.crit)) {
          crit = document.querySelector('#criterion_td_' + this.$route.query.crit);
        }
        if (!crit) {
          crit = document.querySelector('.criterion_td');
        }
        if (crit) {
          crit.click();
          let prnt = crit.parentNode;
          while (prnt) {
            let classList = prnt.classList;
            if (classList.length > 0) {
              if (classList[0] === 'questions_tree') {
                break;
              }
              if (classList[0] === 'tree-item') {
                let childNodes = prnt.childNodes;
                for(let i in childNodes) {
                  let classList2 = childNodes[i].classList;
                  if (classList2 && classList2.length > 0 && classList2[0] === 'table-responsive') {
                    prnt.firstChild.lastChild.click();
                  }
                }
              }
            }
            prnt = prnt.parentNode;   
          }
        }
      })
    },
    registerIndustryChildren(item, prefix) {
      let title = prefix;
      if (item.naceCode && item.naceCode !== '') {
        title += '(' + item.naceCode + ') ';
      }
      title += item.title;
      this.industriesFlat.push({
        code: item.id,
        label: title
      });
      this.industriesIndex[item.id] = title;
      if (item.childrenDtos.length > 0) {
        for (let i in item.childrenDtos) {
          this.registerIndustryChildren(item.childrenDtos[i], prefix + '')
        }
      }
    },
    toggleCompanyEvaluationsNotes(index) {
      let indexOf = this.companyEvaluationsNotes.indexOf(index);
      if (indexOf === -1) {
        this.companyEvaluationsNotes.push(index)
      } else {
        this.companyEvaluationsNotes.splice(indexOf,1);
      }
    },
    fetchFrameworks() {
      let self = this;
      Api.send('GET', '/frameworks', {})
      .then((response) => {
        self.frameworks = response;
        self.fetchPillars();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    fetchPillars() {
      let self = this;
      Api.send('GET', '/pillars', {})
      .then((response) => {
        self.pillars = response;
        self.fetchTopicsTree();
      })
      .catch((err) => {
        self.errorMessage = err.msg;
      });
    },
    pillarIcon(pillar) {
      switch(pillar) {
        case 'environmental':
          return 'icomoon-leaf';
        case 'social':
          return 'icomoon-man-woman';
          case 'governance':
          return 'icomoon-briefcase';
        case 'financial':
          return 'icomoon-coin-euro';
        case 'general':
          return 'icomoon-info';
        default:
          return 'icomoon-earth';
      }
    },
  }
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
}
.questions_tree {
  padding-left: 0;
  line-height: 2em;
  list-style-type: none;
  font-size: 1.2em;
}
.card.environmental {
  border: 2px solid #2dce89;
  background-color: rgb(45 206 137 / 13%);
}
.card.social {
  border: 2px solid #ffd600;
  background-color: rgb(255 214 0 / 13%);
}
.card.governance {
  border: 2px solid #5e72e4;
  background-color: rgb(94 114 228 / 13%);
}
.card.financial {
  border: 2px solid #e45e5e;
  background-color: rgb(228 94 94 / 13%);
}
.card.general {
  border: 2px solid #a1a1a1;
  background-color: rgb(231, 231, 236);
}
.card .info-box {
  background-color: rgb(235, 235, 235);
  margin-top: 10px;
  padding: 10px;
  border-radius: 5px;
}
.info-box ul>li {
  color: inherit;
}
.height-50 {
  height: 50px;
  line-height: 50px;
  font-size: 50px;
}
td.company_logo {
  width: 20%;
}
td.company_trade_title {
  width: 30%;
}
td.evaluation_answer {
  width: 50%;
}
td.evaluation_answer .evaluation_answer_notes {
  font-size: 80%;
}
td.evaluation_answer .evaluation_answer_notes p {
  color: #6c757d !important;
}
table#filters tbody tr td:first-child {
  width:100px !important;
}
#industry_filter.empty::before {
  content: 'All Industries';
  position: absolute;
  top: 5px;
  left: 10px;
}
#country_filter.empty::before {
  content: 'All Countries';
  position: absolute;
  top: 5px;
  left: 10px;
}
</style>
